import { render, staticRenderFns } from "./SmsPatterns.vue?vue&type=template&id=c3399100"
import script from "./SmsPatterns.vue?vue&type=script&lang=js"
export * from "./SmsPatterns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports